import PropTypes from 'prop-types';
import { MdChat, MdFormatQuote, MdLabel, MdMenuBook } from 'react-icons/md';
import styles from './ContentOptionsRibbon.module.css';

const ContentOptionsRibbon = ({
  includeGlossary,
  includeQuote,
  includeCitation,
  includeMetadata,
  onGlossaryChange,
  onQuoteChange,
  onCitationChange,
  onMetadataChange,
}) => {
  return (
    <div className={styles.contentRibbon}>
      <div className={styles.ribbonHeader}>
        <h4 className={styles.ribbonTitle}>Additional Enhancements</h4>
        <p className={styles.ribbonDescription}>Select optional features to enrich your summary with extra context and information</p>
      </div>

      <div className={styles.ribbonOptions}>
        <button
          className={`${styles.ribbonOption} ${includeMetadata ? styles.active : ''}`}
          onClick={onMetadataChange}
        >
          <span className={styles.ribbonLabel}><MdLabel /> Metadata</span>
          <span className={styles.ribbonHelpText}>Document details</span>
        </button>

        <button
          className={`${styles.ribbonOption} ${includeGlossary ? styles.active : ''}`}
          onClick={onGlossaryChange}
        >
          <span className={styles.ribbonLabel}><MdMenuBook /> Glossary</span>
          <span className={styles.ribbonHelpText}>Key terms explained</span>
        </button>

        <button
          className={`${styles.ribbonOption} ${includeQuote ? styles.active : ''}`}
          onClick={onQuoteChange}
        >
          <span className={styles.ribbonLabel}><MdChat /> Quote</span>
          <span className={styles.ribbonHelpText}>Highlight key excerpt</span>
        </button>

        <button
          className={`${styles.ribbonOption} ${includeCitation ? styles.active : ''}`}
          onClick={onCitationChange}
        >
          <span className={styles.ribbonLabel}><MdFormatQuote /> Citation</span>
          <span className={styles.ribbonHelpText}>Reference format</span>
        </button>
      </div>
    </div>
  );
};

ContentOptionsRibbon.propTypes = {
  includeGlossary: PropTypes.bool.isRequired,
  includeQuote: PropTypes.bool.isRequired,
  includeCitation: PropTypes.bool.isRequired,
  includeMetadata: PropTypes.bool.isRequired,
  onGlossaryChange: PropTypes.func.isRequired,
  onQuoteChange: PropTypes.func.isRequired,
  onCitationChange: PropTypes.func.isRequired,
  onMetadataChange: PropTypes.func.isRequired,
};

export default ContentOptionsRibbon;
